import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LOGIN_URL } from '@shared/constants';
import { FLUTTER_FUNCTIONS } from '@shared/helpers/flutter-functions';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken && !request.url.includes('passphrase')) {
      request = request.clone(
        request.params.get('staticFile')
          ? {}
          : {
              setHeaders: {
                Authorization: `Bearer ${accessToken}`
              }
            }
      );
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.Unauthorized) {
          const currentPath = location.pathname;
          //start with auth -> non authenticated screens -> proceed
          //otherwise -> navigate to login screen
          const navigatingUrl = currentPath.startsWith('/auth') ? currentPath : LOGIN_URL;
          localStorage.removeItem('access_token');
          if (navigatingUrl === LOGIN_URL) {
            FLUTTER_FUNCTIONS.backToLogin();
          }
          this.router.navigate([navigatingUrl]);
        }
        return throwError(() => error);
      })
    );
  }
}
